export default class TreeFilter {
    constructor() {
        this.results = null;
    }

    filterNodes() {
        this.results = this.doFilter();
    }

    doFilter() {
        return null;
    }

    getResults() {
        return this.results;
    }

    getFilterClasses() {
        return [];
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/TreeFilter.js